import React from 'react';

export const Guides = ({ width = 24, height = 24 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 0C0.447715 0 0 0.447715 0 1V16C0 16.5523 0.447715 17 1 17H8C8.53043 17 9.03914 17.2107 9.41421 17.5858C9.78929 17.9609 10 18.4696 10 19C10 19.5523 10.4477 20 11 20C11.5523 20 12 19.5523 12 19C12 18.4696 12.2107 17.9609 12.5858 17.5858C12.9609 17.2107 13.4696 17 14 17H21C21.5523 17 22 16.5523 22 16V1C22 0.447715 21.5523 0 21 0H15C13.6739 0 12.4021 0.526784 11.4645 1.46447C11.2962 1.63275 11.1411 1.81178 11 1.99997C10.8589 1.81178 10.7038 1.63275 10.5355 1.46447C9.59785 0.526784 8.32608 0 7 0H1ZM12 15.5359C12.6029 15.1878 13.2918 15 14 15H20V2H15C14.2044 2 13.4413 2.31607 12.8787 2.87868C12.3161 3.44129 12 4.20435 12 5V15.5359ZM10 15.5359V5C10 4.20435 9.68393 3.44129 9.12132 2.87868C8.55871 2.31607 7.79565 2 7 2H2V15H8C8.70823 15 9.39709 15.1878 10 15.5359Z"
        fill="white"
      />
    </svg>
  );
};
